module.exports = __webpack_public_path__ + "img/bbee-qr.696279f5.png";